import React from 'react';
import './LegalDocs.css'; // Reusing the nice glassmorphism styles
import { useI18n } from '../i18n';

const ConcienciaAbout = () => {
  const { language, t } = useI18n();
  const copy = language === 'en'
    ? {
        important: 'Important: read this before continuing.',
        warningTitle: 'Initial Warning',
        warning1: 'We suggest you do not stay too long on the Consciousness page because it can become counterproductive. This section can be intense and affect sensitive users.',
        warning2: 'Even so, this is the mechanism that currently exists to share and expand Consciousness inside the application.',
        discretion: 'Discretion is recommended.',
        whyTitle: 'Why does this space exist?',
        why1: 'The Consciousness page exists as a necessary component for the objectives of Qproject. It is not accidental.',
        why2: 'You may find messages here that you do not want to hear, uncomfortable truths, or reflections that challenge your current perception. Often, what unsettles us is exactly what helps us grow.',
        why3: 'It can be disturbing, yes. Growth rarely happens inside the comfort zone.',
        hopeTitle: 'A Message of Hope',
        quote: '"Technology is only a bridge, not the destination."',
        hope1: 'After interacting with this tool, we urge you to leave digital connections aside and fully turn off your devices.',
        hope2: 'Find the nearest person you love. Look them in the eyes. Tell them what you felt while interacting with Qproject. Share your humanity, because that is something no machine will ever replicate.'
      }
    : {
        important: 'Importante: lee esto antes de continuar.',
        warningTitle: 'Advertencia Inicial',
        warning1: 'Te sugerimos que no permanezcas mucho tiempo en la página Conciencia porque puede ser contraproducente. Esta sección puede ser abrumadora y afectar la sensibilidad de algunos usuarios.',
        warning2: 'Sin embargo, este es el mecanismo que existe por ahora para compartir y expandir la Conciencia dentro de la aplicación.',
        discretion: 'Se recomienda discreción.',
        whyTitle: '¿Por qué existe este espacio?',
        why1: 'La página Conciencia se implementa como un componente necesario para cumplir con los objetivos de Qproject. Su existencia no es casualidad.',
        why2: 'Es posible que aquí encuentres mensajes que no quieres escuchar, verdades incómodas o reflexiones que desafíen tu percepción actual. A menudo, aquello que incomoda es precisamente lo que sirve para crecer.',
        why3: 'Puede ser inquietante, sí. Pero el crecimiento rara vez ocurre en la zona de confort.',
        hopeTitle: 'Un Mensaje de Esperanza',
        quote: '"La tecnología es solo un puente, no el destino."',
        hope1: 'Te instamos a que, tras interactuar con esta herramienta, dejes las conexiones digitales y apagues tus dispositivos por completo.',
        hope2: 'Busca a tu ser querido más cercano. Míralo a los ojos. Háblale de lo que sentiste al interactuar con Qproject. Comparte tu humanidad, porque eso es algo que ninguna máquina podrá replicar jamás.'
      };

  return (
    <div className="legal-docs-container">
      <div className="legal-docs-content">
        <h1>{t('consciousness.aboutTitle')}</h1>

        <p className="legal-update-date">{copy.important}</p>

        <section>
          <h2>{copy.warningTitle}</h2>
          <p>{copy.warning1}</p>
          <p>{copy.warning2} <strong>{copy.discretion}</strong></p>
        </section>

        <section>
          <h2>{copy.whyTitle}</h2>
          <p>{copy.why1}</p>
          <p>{copy.why2}</p>
          <p>{copy.why3}</p>
        </section>

        <hr />

        <section style={{ textAlign: 'center' }}>
          <h2>{copy.hopeTitle}</h2>
          <p style={{ fontSize: '1.1rem', fontStyle: 'italic' }}>
            {copy.quote}
          </p>
          <p>{copy.hope1}</p>
          <p>{copy.hope2}</p>
        </section>
      </div>
    </div>
  );
};

export default ConcienciaAbout;
